import listComponent from '@/util/proto/listComponent'
import License from '../license'

import './index.less'
//0、申请中，1、待开始考试，2、考试中，3，考试完成（待发放），4、申请不通过，5、驾照已经发放，6、待申请
const stateIcon = [
  { value: 0, label: 'warning' },
  { value: 1, label: 'warning' },
  { value: 2, label: 'processing' },
  { value: 3, label: '#2d8cf0' },
  { value: 4, label: 'error' },
  { value: 5, label: 'success' },
  { value: 6, label: 'warning' },
]

export default {
  extends: listComponent,
  props:['companyId','value'],
  data(){
    return {
      data:[],
      loading:false,
      visible:false,
      stats:{
        cert:0 , 
        total:0
      },
      company:{},
    }
  },
  created(){
    this.$watch('companyId' , function(nv , ov){
      if(nv){
        this.search()
      }
    },{immediate:true , deep:false})
  },
  methods:{
    init(data){
      if( data === false ){
        this.visible = false
        this.company = {}
      }else{
        this.visible = true
        this.company = data
        this.search(data.id)
      }
    },
    search(id){
      this.data = []
      this.loading = true
     
      this.$request.screenCourierInCompany(id || this.companyId).then( resp => {
        this.loading = false
        this.data = this.$utils.conv( resp.data || [] , { 'examState':'examState','examState:stateIcon':stateIcon,'phone':'privacy:mobile','idcard':'privacy:idcard'}).sort((a,b) => a.examState == 5 ? -1 : 1)
        this.stats.total = resp.data.length
        this.stats.cert = resp.data.reduce((t,c) => t + (c.examState == 5 ? 1 : 0),0)
      })
    },
    reset(){
      this.data = []
    },
    handleFullCar(){
      this.$emit('full')
    },
    toggleData(){

    },
    handleClick(data){
      this.$emit('click' , data)
    },
    handleClose(){
      this.visible = false
    },
    handleShowCert(row){
      console.log(row)
      this.$dialog({
        // title:'新增时段价格',
        width:400,
        paddingless:true,
        className:'screen-dialog',
        render:(h)=>{
          return <License data={row.cert} />
        },
      })
    },
  },
  render(){
    const stats = this.stats
    const company = this.company || {}
    return (
      <div class={["screen-carlist" , this.visible ? 'screen-carlist--visible' : null]}>
        <div class="screen-carlist__close" on-click={this.handleClose}><Icon type="ios-close" /></div>

        <div class="screen-carlist__header">
          <Avatar style="margin-right:8px;flex:none;" src={company.icon} size="large" />
          <span>{company.name}</span>
        </div>
        
        <div class="screen-carlist__stats">
          <div class="screen-carlist__stats-item">
            人员： { stats.total}
          </div>
          <div class="screen-carlist__stats-item">
            已取证： {stats.cert}
          </div>
        </div>
        <div class="screen-carlist__body">
        <sl-spin loading={this.loading}>
          { 
            this.data.map(row => (
              <div class="screen-carlist__item" on-click={() => this.handleClick(row)} >
                <div class="screen-carlist__item-header">
                  <div>
                    <span>{row.name}</span>
                    {
                      row.carNo ? <span style="margin-left:8px;">No.{row.carNo}</span> : null
                    }
                    
                  </div>
                  <div on-click={() => this.handleShowCert(row)}>
                    {
                      row.examState == 5 ? <a><Icon custom="i-icon icon-credentials" />{row.examStateText}</a> : <div><sl-badge style={{'marginRight':'12px'}} status={row.stateIcon} />{row.examStateText}</div>
                    }
                  </div>
                </div>
                <div class="screen-carlist__item-body">
                  <div class><span class="label">电话号码：</span>{row.phoneText}</div>
                  <div>
                    <span class="label">身份证号：</span>{row.idcardText}
                  </div>
                </div>
              </div>
            ))
          }
        </sl-spin>
        </div>
      </div>
    )
  }
}